{
  "id": "skirmish_13",
  "name": "Skirmish-13",
  "mode": "HOTSEAT_2_4P",
  "ruleset": "OFFICIAL_SKIRMISH",
  "objective": "Eliminate every opposing team by removing its final figure.",
  "randomStart": true,
  "credits": {"EFA": 20, "REDCAT": 20, "GREEN": 20, "BLUE": 20},
  "terrain": [
    "VDVDVDVDVDVDVDVDVDVDV",
    "DDDDDDDDDDDDDDDDDDDDD",
    "DDFDDDDDDDNDDNNDDDFDD",
    "DDDDDDNNDDDDDDDDDDDDD",
    "DFDDDDDDDDDDDDDDDDDFD",
    "DDDNDDDDDDDDDDDDDNDDD",
    "DDDDNDDDDDDDDDDDNDDDD",
    "DDDDDDDDDDDDNDDDDDDDD",
    "DNDDDDDDNDDDDDDDDDDND",
    "DNDDDDDDDDDDDDDDDDDND",
    "DDDDDDDDDDDDDDDDDDDDD",
    "DDDNDDDDNDDDNDDDDDDDD",
    "DDNDDDDDDDDDDDDDNNDDD",
    "DFDDDDDDDDDDDDDDDDDFD",
    "DDDDDDDDDDDDDDDDDDDDD",
    "DDDDDNNDDDDDDNDDDDDDD",
    "DDFDDDDDDDNDDDNDDDFDD",
    "DDDDDDDDDDDDDDDDDDDDD"
  ],
  "ore": [[5,6],[6,6],[7,6],[5,7],[6,7],[7,7],[6,8],[13,6],[14,6],[15,6],[13,7],[14,7],[15,7],[14,8],[5,10],[6,10],[7,10],[5,11],[6,11],[7,11],[6,12],[13,10],[14,10],[15,10],[13,11],[14,11],[15,11],[14,12]],
  "pieces": [
    {"type":"MCV","owner":"EFA","col":1,"row":0},
    {"type":"MCV","owner":"BLUE","col":20,"row":1},
    {"type":"MCV","owner":"GREEN","col":0,"row":17},
    {"type":"MCV","owner":"REDCAT","col":19,"row":17}
  ]
}
